import { SelectHTMLAttributes } from "react";
import { siteTexts } from "../i18n/siteTexts";
import AppSelect from "./AppSelect";

export const PLAYER_CATEGORY_OPTIONS = [
  { value: "open", label: siteTexts.common.category.open },
  { value: "2a", label: siteTexts.common.category.c2a },
  { value: "3a", label: siteTexts.common.category.c3a },
  { value: "4a", label: siteTexts.common.category.c4a },
  { value: "5a", label: siteTexts.common.category.c5a },
  { value: "6a", label: siteTexts.common.category.c6a },
  { value: "7a", label: siteTexts.common.category.c7a },
];

type PlayerCategorySelectProps = Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  "children"
> & {
  allLabel?: string;
  allValue?: string;
  includeAll?: boolean;
  includeOpen?: boolean;
  options?: typeof PLAYER_CATEGORY_OPTIONS;
};

export function playerCategoryLabelFromCode(code?: string | null) {
  return (
    PLAYER_CATEGORY_OPTIONS.find((option) => option.value === code)?.label || ""
  );
}

export function isPlayerCategoryCode(value: string) {
  return PLAYER_CATEGORY_OPTIONS.some((option) => option.value === value);
}

export default function PlayerCategorySelect({
  allLabel = siteTexts.common.filters.allCategories,
  allValue = "",
  includeAll = false,
  includeOpen = true,
  options: customOptions,
  ...props
}: PlayerCategorySelectProps) {
  const options =
    customOptions ||
    (includeOpen
      ? PLAYER_CATEGORY_OPTIONS
      : PLAYER_CATEGORY_OPTIONS.filter((option) => option.value !== "open"));

  return (
    <AppSelect {...props}>
      {includeAll && <option value={allValue}>{allLabel}</option>}
      {options.map((option) => (
        <option key={`player-category-${option.value}`} value={option.value}>
          {option.label}
        </option>
      ))}
    </AppSelect>
  );
}
